export default __webpack_public_path__ + "static/media/gallery-wip-grenade_03.95141d0a.jpg";